import React, { useState, useEffect } from 'react'
import { components, useServices, useTranslation } from 'cng-web-lib'
import AciHighwayCargoApiUrls from '../../../../apiUrls/AciHighwayCargoApiUrls'
import { Box, Grid, Paper } from '@material-ui/core'
import { FileForUserGetUserDetails } from 'src/common/FileForUserCommon'
import ErrorMessageSection from 'src/views/common/ErrorMessageSection'
import ACIHighwayManifestTranslationText from './../../contexts/ACIHighwayManifestTranslationText'

const {
  button: { CngButton },
  dropzone: { CngFileUpload },
  CngDialog
} = components

function CargoUploadDialog(props) {
  const { manifestId, onClose, open, showNotification } = props

  const [files, setFiles] = useState([])
  const [errorMessages, setErrorMessages] = useState([])
  const [loading, setLoading] = useState(false)
  const { securedSendRequest } = useServices()
  const aciHighwayManifestTranslationText = ACIHighwayManifestTranslationText()

  useEffect(() => {
    setFiles([])
    setErrorMessages([])
  }, [open]);

  const downloadFile = () => {
    const blob = new Blob(["Cargo Type,Consolidate Indicator,Paper Release,Cargo Control Number,First Expected Port,ETA,ETA Time,ETA Time Zone,Inbond Destination Office Code,Warehouse Code,Print Remark,Place Of Loading City,Place Of Loading State,Place Of Loading Country,Place Of Acceptance City Name,Place Of Acceptance State,Place Of Acceptance Country,Admin Contact Name,Admin Contact No,Special Instruction,Shipper Name,Shipper Address,Shipper City,Shipper State,Shipper Country,Shipper Postal Code,Shipper Contact Name,Shipper Contact No,Business No,Consignee Name,Consignee Address,Consignee City,Consignee State,Consignee Country,Consignee Postal Code,Consignee Contact Name,Consignee Contact No,Delivery Party Name,Delivery Party Address,Delivery Party City,Delivery Party State,Delivery Party Country,Delivery Party Postal Code,Delivery Party Admin Name,Delivery Party Admin Contact No,Notify Party Name,Notify Party Address,Notify Party City,Notify Party State,Notify Party Country,Notify Party Postal Code,Notify Party Admin Name,Notify Party Admin Contact No,Commodity No,Commodity Description,Commodity Quantity,Commodity UOM,Commodity Weight,Commodity Weight UOM,HS Code,UNDG Code 1,UNDG Description 1,UNDG Contact Name 1,UNDG Contact No 1,UNDG Code 2,UNDG Description 2,UNDG Contact Name 2,UNDG Contact No 2,Marks And No\nREGULAR,N,,1234PARS001,453,,,,,,,New York,NY,US,,,,,,,Crimsonlogic US,Address,New York,NY,US,12345,,,,Crimsonlogic CA,address1,Toronto,ON,CA,A3A 3A3,,,,,,,,,,,,,,,,,,,commodityNo,Descr,100,BAG,100,K,,,,,,,,,,\nREGULAR,N,,1234PARS002,453,,,,,,,New York,NY,US,,,,,,,Crimsonlogic US,Address,New York,NY,US,12345,,,,Crimsonlogic CA,address1,Toronto,ON,CA,A3A 3A3,,,,,,,,,,,,,,,,,,,commodityNo,Descr,100,BAG,100,K,,,,,,,,,,\nREGULAR,N,,1234PARS003,453,,,,,,,New York,NY,US,,,,,,,Crimsonlogic US,Address,New York,NY,US,12345,,,,Crimsonlogic CA,address1,Toronto,ON,CA,A3A 3A3,,,,,,,,,,,,,,,,,,,commodityNo,Descr,100,BAG,100,K,,,,,,,,,,\nREGULAR,N,,1234PARS004,453,,,,,,,New York,NY,US,,,,,,,Crimsonlogic US,Address,New York,NY,US,12345,,,,Crimsonlogic CA,address1,Toronto,ON,CA,A3A 3A3,,,,,,,,,,,,,,,,,,,commodityNo,Descr,100,BAG,100,K,,,,,,,,,,\nREGULAR,N,,1234PARS005,453,,,,,,,New York,NY,US,,,,,,,Crimsonlogic US,Address,New York,NY,US,12345,,,,Crimsonlogic CA,address1,Toronto,ON,CA,A3A 3A3,,,,,,,,,,,,,,,,,,,commodityNo,Descr,100,BAG,100,K,,,,,,,,,,"], { type: "text/csv" })
    const element = document.createElement("a");
    element.href = window.URL.createObjectURL(blob)
    element.download = "ACIHWY_Cargo_SampleUpload.csv";
    document.body.appendChild(element);
    element.click();
    element.parentNode.removeChild(element);
  }

  function handleUploadCargo() {
    try {
      if (!files || files.length === 0) {
        showNotification('error', aciHighwayManifestTranslationText.noFileAttachError);
        return;
      }

      setLoading(true)

      let fileForUserDetails = FileForUserGetUserDetails();
      const formData = new FormData()

      formData.append('file', files[0].file)
      formData.append('manifestId', manifestId)
      if (fileForUserDetails != null && fileForUserDetails != undefined) {
        formData.append("fileForUserDetails", JSON.stringify(fileForUserDetails))
      } else {
        formData.append("fileForUserDetails", "{}")
      }

      securedSendRequest.execute(
        'POST',
        AciHighwayCargoApiUrls.UPLOAD,
        formData,
        (response) => {
          if (response.status === 200) {
            if (response.data) {
              const errorMessages = response.data.errorMessages

              if (errorMessages) {
                setErrorMessages(errorMessages)
                setFiles([])
              }
            }else{
              showNotification('success', aciHighwayManifestTranslationText.fileUploadSuccess)
              onClose()
              open.tableRef.current.performRefresh()
            }
          }
        },
        () => {
          showNotification('error', aciHighwayManifestTranslationText.fileUploadError)
          setFiles([])
        },
        () => setLoading(false)
      )
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <CngDialog
      dialogTitle={aciHighwayManifestTranslationText.uploadCargoTitle}
      dialogContent={
        <Paper variant='outlined'>
          <Box padding={2}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <CngFileUpload
                  accept={['.csv']}
                  files={files}
                  maxFiles={1}
                  maxSize={6291456}
                  onFileSelect={(file) => setFiles(file)}
                  showFormFields={false}
                  moreActions={[
                    {
                      action: 'remove',
                      name: aciHighwayManifestTranslationText.removeButton,
                      icon: ['fal', 'trash']
                    }
                  ]}
                  onDropRejected={(errorMessages) => showNotification('error', errorMessages)}
                />
              </Grid>

              <ErrorMessageSection errorMessages={errorMessages} />

              <Grid item xs={12}>
                <Grid container justify='flex-end' spacing={2}>
                  <Grid item xs='auto'>
                    <CngButton size='medium' variant='outlined' onClick={downloadFile}>
                      {aciHighwayManifestTranslationText.downloadCSVTemplateButton}
                    </CngButton>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Box>
        </Paper>
      }
      dialogAction={
        <>
          <CngButton color='secondary' disabled={loading} onClick={onClose}>
            {aciHighwayManifestTranslationText.discardButton}
          </CngButton>
          <CngButton
            color='primary'
            disabled={loading}
            onClick={handleUploadCargo}
            shouldShowProgress={loading}
          >
            {aciHighwayManifestTranslationText.saveButton}
          </CngButton>
        </>
      }
      fullWidth
      maxWidth='lg'
      open={open}
      onClose={onClose}
      shouldShowCloseButton
    />
  )
}

export default CargoUploadDialog
